// extracted by mini-css-extract-plugin
module.exports = {"field":"HdT++","description":"H-fps"};